export var pleaseConfirm = function pleaseConfirm(fieldName) {
  return "Please confirm whether they are a ".concat(fieldName, ".");
};
var defaultFieldName = "student dependant";
var VARIANTS = {
  ARHI: defaultFieldName
};
var validStudentDependant = function validStudentDependant(value, fieldName) {
  var error; // eslint-disable-line init-declarations
  var derivedFieldName = fieldName || VARIANTS.ARHI;
  if (!value || value === "unselected") {
    error = pleaseConfirm(derivedFieldName);
  }
  return error;
};
export default validStudentDependant;